<template>
    <NuxtLayout name="main" :top="0">
        <ModuleDetail mode="Disease" v-bind="options" :data="data">
            <module-component1
                :origin="data"
                ref="module1"
                @move3="methods.move(module3)"
                @move5="methods.move(module5)"
                @move6="methods.move(module6)" />
            <module-component2 :origin="data" ref="module2" />
            <module-component3 :origin="data" ref="module3" />
            <module-component4 :origin="data" ref="module4" />
            <module-component5 :origin="data" ref="module5" />
            <module-component6 :origin="data" ref="module6" />
        </ModuleDetail>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 公共组件
import ModuleDetail from "../components/container/index.vue";
//* 内部组件
import ModuleComponent1 from "./components/module1/index.vue";
import ModuleComponent2 from "./components/module2/index.vue";
import ModuleComponent3 from "./components/module3/index.vue";
import ModuleComponent4 from "./components/module4/index.vue";
import ModuleComponent5 from "./components/module5/index.vue";
import ModuleComponent6 from "./components/module6/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";

//* 插件
const route = useRoute();

//* 组合函数
const { nodes, methods, computeds } = useComposable();
const { module1, module2, module3, module4, module5, module6 } = nodes;
const { options } = computeds;

//* 页面数据初始化
const data = await api.server("DiseaseDetails", "/api/disease", {
    data: { id: route.params.id },
    method: "POST",
});

//* 获取接口数据，初始化模块
onMounted(async () => {
    //* 请求列表
    const requests: Promise<any>[] = [];

    //* 请求注册
    requests.push(methods.register("/api/disease/characterization", module2.value, "POST"));
    requests.push(methods.register("/api/related/drugs", module4.value));
    requests.push(methods.register("/api/disease/models", module5.value));

    //* 批量请求
    try {
        Promise.all(requests).then(() => {
            nextTick(() => {
                if (route.query.module) {
                    const module = route.query.module as "module1" | "module2" | "module3" | "module4" | "module5" | "module6";
                    setTimeout(() => methods.move(nodes[module].value), 1000);
                }
            });
        });
    } catch {}
});
</script>

<style>
.modules {
    max-width: 1920px;
    background-color: #fff;
    margin: 0 auto;
}
</style>
